/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Nav_Create_Folder_Success_ToastInputs */

const en_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Folder "${i?.name}" created`)
};

const fr_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dossier "${i?.name}" cree`)
};

const de_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ordner "${i?.name}" erstellt`)
};

const it_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cartella "${i?.name}" creata`)
};

const ru_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Создана папка "${i?.name}".`)
};

const es_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carpeta "${i?.name}" creada`)
};

const zh_cn2_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`创建文件夹“${i?.name}”`)
};

const ja_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フォルダ「${i?.name}」を作成しました`)
};

const hi_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर "${i?.name}" बनाया गया`)
};

const pt_pt2_explorer_nav_create_folder_success_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pasta "${i?.name}" criada`)
};

/**
* | output |
* | --- |
* | "Folder \"{name}\" created" |
*
* @param {Explorer_Nav_Create_Folder_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_create_folder_success_toast = /** @type {((inputs: Explorer_Nav_Create_Folder_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Create_Folder_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_create_folder_success_toast(inputs)
	if (locale === "de") return de_explorer_nav_create_folder_success_toast(inputs)
	if (locale === "it") return it_explorer_nav_create_folder_success_toast(inputs)
	if (locale === "ru") return ru_explorer_nav_create_folder_success_toast(inputs)
	if (locale === "es") return es_explorer_nav_create_folder_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_create_folder_success_toast(inputs)
	if (locale === "ja") return ja_explorer_nav_create_folder_success_toast(inputs)
	if (locale === "hi") return hi_explorer_nav_create_folder_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_create_folder_success_toast(inputs)
	return en_explorer_nav_create_folder_success_toast(inputs)
});